import request from '@/utils/request'
import { PurchaseItem, PurchaseDetail, ServiceItem } from '@/types/standby'

export function GetPurchaseHistories(query: { sn: string }): Promise<PurchaseItem[]> {
  return request.get('/api/agri/agriculture_backup_machine/purchase_history', { params: query })
}

export function GetPurchaseDetail(query: { pay_order: string }): Promise<PurchaseDetail[]> {
  return request.get('/api/agri/agriculture_backup_machine/purchase_detail', { params: query })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function GetServiceHistories(query: { sn: string }): Promise<ServiceItem[]> {
  return request.get('/api/agri/agriculture_backup_machine/service_history', { params: query })
}
